export enum WeightUnit {
	Kilogram = 0,
	Pounds = 1,
	BananaBox = 2
}